import { render } from "./setDiscountSmartoilPoints.vue?vue&type=template&id=1911edf2&scoped=true"
import script from "./setDiscountSmartoilPoints.vue?vue&type=script&lang=js"
export * from "./setDiscountSmartoilPoints.vue?vue&type=script&lang=js"

import "./setDiscountSmartoilPoints.vue?vue&type=style&index=0&id=1911edf2&lang=scss"
import "./setDiscountSmartoilPoints.vue?vue&type=style&index=1&id=1911edf2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1911edf2"]])

export default __exports__